import React from 'react';
import { Icon } from './Icon.jsx';
import { LogoMark } from './LogoMark.jsx';
import { AAConsent, loadCalendly } from './CookieBanner.jsx';
import { trackCTAClick, trackScheduleIntent, trackFAQOpen, withUtm } from '../lib/tracking.js';


const { useState: useState_b } = React;

const CALENDLY_URL = 'https://calendly.com/dominik-gross/infogesprach-app-academy-ws?hide_gdpr_banner=1';
const openCalBot = async (e) => {
  e.preventDefault();
  const c = AAConsent.current();
  if (!c.functional || !c.statistics || !c.marketing) {
    AAConsent.set({ functional: true, statistics: true, marketing: true });
  }
  trackCTAClick({ label: 'Termin buchen', location: 'bot', destination: 'calendly' });
  trackScheduleIntent({ location: 'bot' });
  const url = withUtm(CALENDLY_URL);
  try {
    await loadCalendly();
    window.Calendly.initPopupWidget({ url });
  } catch {
    window.open(url, '_blank');
  }
};

// =================== PACKAGES ===================
export function Packages() {
  const offer = {
    name: 'Academy Pro',
    tagline: 'Der vollständige Videokurs plus persönliche Live-Begleitung durch erfahrene App-Experten.',
    investment: '3 Monate persönliche Live-Betreuung in kleiner Gruppe',
    features: [
      'Vollständiger Videokurs · 50+ Lektionen',
      'Alle Lernmaterialien & Templates',
      'Schritt für Schritt von der Idee bis in den Store',
      '3 Monate Live-Gruppen-Calls (2× pro Woche)',
      'Fragen direkt von Experten beantwortet',
      'Aufzeichnungen aller Sessions',
      'Exklusives Experten-Forum',
      'Lebenslanger Zugriff & alle Updates',
    ],
    cta: 'Platz im Gespräch sichern',
  };

  return (
    <section className="section" id="pakete">
      <div className="container">
        <div className="packages-intro">
          <div className="section-head" style={{marginBottom: 0, maxWidth: 640}}>
            <span className="eyebrow">Dein Weg zum Ergebnis</span>
            <h2 className="section-title">Deine persönliche Begleitung bis zur fertigen <span className="serif-italic">App</span>.</h2>
            <p className="lead">Ein Programm, das alles vereint: der vollständige Videokurs plus 3 Monate persönliche Live-Begleitung durch erfahrene App-Experten.</p>
          </div>
          <span className="availability">
            <span className="live-dot"></span>
            <span className="availability-text">
              Damit wir <strong>persönlich begleiten</strong> können, arbeiten wir bewusst in kleinen Gruppen
            </span>
          </span>
        </div>

        <div className="packages-single">
          <div className="package featured">
            <span className="package-badge">★ App Academy</span>
            <span className="package-tier">Das Programm</span>
            <div className="package-name">{offer.name}</div>
            <div className="package-tagline">{offer.tagline}</div>

            <div className="package-investment">
              <div className="package-investment-label">Im Kern</div>
              <div className="package-investment-value">{offer.investment}</div>
            </div>

            <ul className="package-features">
              {offer.features.map((f, j) => (
                <li key={j}>
                  <Icon.Check size={16}/>
                  <span>{f}</span>
                </li>
              ))}
            </ul>

            <a href="#" onClick={openCalBot} className="btn btn-primary">
              {offer.cta}
              <span className="btn-arrow"><Icon.ArrowRight size={14}/></span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

// =================== FAQ ===================
export function FAQ() {
  const [open, setOpen] = useState_b(0);

  const items = [
    {
      q: 'Ich kann nicht programmieren. Funktioniert das wirklich für mich?',
      a: 'Ja, genau dafür ist die Academy gemacht. Mehr als 80 % unserer Teilnehmer:innen kommen ohne jede Code-Erfahrung. Du beschreibst in normaler Sprache, was deine App tun soll. Die KI (Cursor mit Flutter, Gemini) schreibt den Code. Unser Team gibt dir die Struktur, die Templates und die persönliche Begleitung, damit am Ende nicht "Code", sondern eine fertige App im Store steht.'
    },
    {
      q: 'Funktioniert KI 2026 wirklich gut genug für eine produktive App?',
      a: 'Ja. Unsere eigenen Apps mit Millionen Downloads werden heute zu großen Teilen mit KI gebaut. Mit den richtigen Tools (Cursor, Flutter, Firebase, Gemini), dem richtigen Prompting und einem ganzen Team aus erfahrenen App-Experten im Rücken erreichst du als Einsteiger Produktqualität, die früher nur teure Agenturen abliefern konnten. Genau dieses Praxiswissen vermitteln wir.'
    },
    {
      q: 'Ist die App Academy nicht zu teuer?',
      a: 'Frag dich umgekehrt: Was kostet dich KEINE App? Eine klassische App-Agentur ruft 50.000 € bis 100.000 € auf. Und nach dem Launch zahlst du jedes Update extra. Bei uns investierst du einen Bruchteil, behältst volle Kontrolle und nimmst einen Skill mit, der dir dein Leben lang gehört. Im kostenlosen Infogespräch besprechen wir transparent, ob das Programm für dein Vorhaben sinnvoll ist und welche Investition damit verbunden ist.'
    },
    {
      q: 'Wie verdiene ich später Geld mit meiner App?',
      a: 'Genau das ist Modul 5 der App Academy. Du lernst alle gängigen Modelle: Freemium, Abos via RevenueCat, Einmalkäufe, Werbung. Wir gehen mit dir durch echte Zahlen aus unseren eigenen Apps und finden gemeinsam heraus, welches Modell zu deiner Zielgruppe passt. Viele Teilnehmer haben innerhalb der ersten Wochen nach Launch erste Einnahmen.'
    },
    {
      q: 'Was passiert nach den 6 Wochen. Bin ich dann allein?',
      a: 'Nein. Die offiziellen 6 Wochen enden, aber der Support läuft weiter: Experten-Forum, lebenslanger Zugriff auf alle Inhalte und Updates. In der Live-Begleitung bekommst du deine verbleibenden Sessions mit unserem Team, um die App final in den Store zu bringen oder Updates zu planen.'
    },
    {
      q: 'Wie viel Zeit brauche ich pro Woche?',
      a: '5 bis 10 Stunden pro Woche reichen für ein solides Ergebnis. Die Inhalte sind so aufgebaut, dass du sie flexibel einteilen kannst. Nebenbei zum Hauptberuf, abends oder am Wochenende. Wer mehr Zeit investiert, kommt schneller voran. Wer weniger Zeit hat, behält trotzdem Anschluss durch die Aufzeichnungen.'
    },
    {
      q: 'Welche Arten von Apps kann ich umsetzen?',
      a: 'Fast alle: Fitness- und Coaching-Apps, Community-Apps, Lern-Apps, B2B-Tools, Branded-Apps für dein Unternehmen, Marketplace-Prototypen, Content-Apps mit Abo-Modell, KI-Apps mit Gemini-Anbindung. Im Infogespräch prüfen wir gemeinsam, ob deine Idee in 6 Wochen realistisch umsetzbar ist.'
    },
    {
      q: 'Brauche ich spezielle Hardware oder Software?',
      a: 'Du brauchst einen modernen Laptop (Mac oder Windows) und einen stabilen Internetzugang. Am ersten Tag installierst du anhand unserer Video-Anleitung ein paar Tools (Cursor, Flutter SDK, Git). Das ist in einer Stunde erledigt und Schritt für Schritt im Video erklärt. Für den Launch im Apple App Store benötigst du einen Apple Developer Account, für Google Play einen Google Play Developer Account.'
    },
    {
      q: 'Wer begleitet mich konkret? Nur Dominik?',
      a: 'Nein. Hinter der App Academy steht ein ganzes Team aus erfahrenen Senior Developern der Incibit GmbH. Sie begleiten dich gemeinsam mit Dominik durch die App Academy. Dominik ist Gründer und Stammgast in den Live-Calls. Im Tagesgeschäft profitierst du vom geballten Wissen des gesamten Teams. Genau das macht den Unterschied zu einem reinen Online-Kurs.'
    },
    {
      q: 'Wie läuft das Infogespräch ab?',
      a: 'Etwa 30 Minuten online via Webkonferenz. Wir besprechen deine Idee, deine Ziele und prüfen gemeinsam, ob die App Academy für dich passt. Du erfährst transparent, wie das Programm abläuft und welche Investition damit verbunden ist. Erst danach entscheidest du, ob du teilnehmen möchtest. Komplett unverbindlich.'
    },
  ];

  return (
    <section className="section" id="faq">
      <div className="container">
        <div className="section-head section-head-center">
          <span className="eyebrow">Häufige Fragen</span>
          <h2 className="section-title">Was Entscheider <span className="serif-italic">vor dem Gespräch</span> wissen wollen.</h2>
        </div>
        <div className="faq-grid">
          {items.map((it, i) => (
            <div className={`faq-item ${open === i ? 'open' : ''}`} key={i}>
              <button
                className="faq-q"
                onClick={() => {
                  const willOpen = open !== i;
                  setOpen(willOpen ? i : -1);
                  if (willOpen) trackFAQOpen({ question: it.q, position: i });
                }}
              >
                <span>{it.q}</span>
                <span className="faq-toggle"><Icon.Plus size={14}/></span>
              </button>
              <div className="faq-a">{it.a}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// =================== FINAL CTA ===================
export function CTAFinal() {
  return (
    <section className="cta-final" id="cta">
      <div className="container">
        <div className="cta-final-content">
          <span className="eyebrow" style={{marginBottom: 24, display:'inline-flex', justifyContent:'center'}}>Dein nächster Schritt</span>
          <h2>Lass uns über deine <em className="serif-italic">App-Idee</em> sprechen.</h2>
          <p>Im kostenlosen 30-Minuten-Infogespräch prüfen wir gemeinsam, ob die App Academy für dich passt und wie das Programm für dein Vorhaben aussieht. Unverbindlich. Transparent. Ohne Verkaufsdruck.</p>
          <a href="#" onClick={openCalBot} className="btn btn-primary btn-xl">
            <span className="btn-label-stack">
              <span className="btn-main">Kostenloses Infogespräch buchen</span>
              <span className="btn-sub">30 Min · online · unverbindlich</span>
            </span>
            <span className="btn-arrow"><Icon.ArrowRight size={18}/></span>
          </a>
          <div className="cta-meta">
            <span><Icon.CheckCircle size={14}/> 30 Minuten · online</span>
            <span><Icon.CheckCircle size={14}/> Komplett unverbindlich</span>
            <span><Icon.CheckCircle size={14}/> Transparente Einschätzung</span>
          </div>
        </div>
      </div>
    </section>
  );
}

// =================== FOOTER ===================
export function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <a href="#top" className="logo">
              <div className="logo-mark"><LogoMark size={32}/></div>
              <span className="logo-text">App Academy</span>
            </a>
            <p>Deine App. Sechs Wochen. Null Code. Persönlich begleitet vom Team der Incibit GmbH. Über 15 Jahre App-Erfahrung. 30+ veröffentlichte Apps. 1 Mio.+ Downloads.</p>
          </div>
          <div className="footer-col">
            <h4>Programm</h4>
            <ul>
              <li><a href="#warum">Warum jetzt</a></li>
              <li><a href="#lehrplan">Lehrplan</a></li>
              <li><a href="#guide">PDF-Guide</a></li>
              <li><a href="#pakete">Pakete</a></li>
              <li><a href="#faq">FAQ</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Über</h4>
            <ul>
              <li><a href="#coach">Team</a></li>
              <li><a href="#stimmen">Cases</a></li>
              <li><a href="https://incibit.at" target="_blank" rel="noreferrer">Incibit</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Rechtliches</h4>
            <ul>
              <li><a href="https://incibit.dev/impressum/" target="_blank" rel="noreferrer">Impressum</a></li>
              <li><a href="https://incibit.dev/privacy-policy/" target="_blank" rel="noreferrer">Datenschutz</a></li>
              <li><a href="https://incibit.dev/agb/" target="_blank" rel="noreferrer">AGB</a></li>
              <li>
                <a
                  href="#cookie-settings"
                  onClick={(e) => { e.preventDefault(); AAConsent.openSettings(); }}
                >
                  Cookie-Einstellungen
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-trust">
          <div className="footer-trust-org">
            <span className="footer-trust-name">Incibit GmbH</span>
            <span className="footer-trust-sep"></span>
            <a href="tel:+43316237766">+43 316 23 77 66</a>
            <span className="footer-trust-sep"></span>
            <a href="mailto:office@incibit.dev">office@incibit.dev</a>
          </div>
          <div className="footer-trust-badges">
            <span className="footer-trust-badge">15+ Jahre App-Studio</span>
            <span className="footer-trust-badge">DSGVO-konform</span>
            <span className="footer-trust-badge">kmu.digital zertifiziert</span>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© 2026 Incibit GmbH · App Academy</span>
          <span>Made with care in Graz, AT</span>
        </div>
      </div>
    </footer>
  );
}

